module.exports = __webpack_public_path__ + "img/44_button.b41da3be.png";